// ─── BUSINESS DEALS ────────────────────────────────────────────────────────
// To add images: replace null with your image URL

export const BUSINESS = [
  // ── SIM-ONLY BUSINESS PLANS ───────────────────────────────────────────────
  {
    id: 1, category: 'SIM-Only', name: 'RED BUSINESS 3.7GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 1680',
    package: 'RED BUSINESS 3.7GB', data: '3.7GB Anytime', minutes: '150', onceOff: '30GB',
    price: 599, wasPrice: null, save: null, term: 36,
    priceAlt: 749, termAlt: 24,
    perks: ['FLySafair discount', 'Europcar discount', 'Marriott Hotel up to 35% off'],
  },
  {
    id: 2, category: 'SIM-Only', name: 'RED BUSINESS 7.6GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 3600',
    package: 'RED BUSINESS 7.6GB', data: '7.6GB Anytime', minutes: '400', onceOff: '30GB',
    price: 1349, wasPrice: 1449, save: 3600, term: 36,
    priceAlt: 1799, termAlt: 24,
    perks: ['FLySafair discount', 'Europcar discount', 'Marriott Hotel up to 50% off'],
  },
  {
    id: 3, category: 'SIM-Only', name: 'RED BUSINESS 23.8GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 4800',
    package: 'RED BUSINESS 23.8GB', data: '23.8GB Anytime', minutes: '1000', onceOff: '30GB',
    price: 799, wasPrice: 999, save: 4800, term: 24,
    priceAlt: null, termAlt: null,
    perks: ['Priority service desk', 'Bidvest Lounge 4 visits/year', 'Full RED VIP rewards'],
  },

  // ── BUSINESS INTERNET ─────────────────────────────────────────────────────
  {
    id: 4, category: 'Business Internet', name: 'Business Internet 5G 30Mbps',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'GET ONLINE IN MINUTES',
    package: 'Business Internet 5G/FWA', data: 'Unlimited', minutes: null, onceOff: null,
    speed: '30Mbps', price: 349, wasPrice: null, save: null, term: 36,
    priceAlt: 399, termAlt: 24,
    note: 'Includes Vodacom X25 Max 2 Router. Professional outdoor installation available.',
  },
  {
    id: 5, category: 'Business Internet', name: 'Business Internet 5G 50Mbps',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'Business Internet 5G/FWA', data: 'Unlimited', minutes: null, onceOff: null,
    speed: '50Mbps', price: 499, wasPrice: null, save: null, term: 36,
    priceAlt: 549, termAlt: 24,
    note: 'Includes Vodacom X25 Max 2 Router. Add 250 VoIP Minutes for R135 PMx24.',
  },

  // ── FEATURED BUSINESS DEVICES ─────────────────────────────────────────────
  {
    id: 6, category: 'Business Devices', name: 'Samsung Galaxy S26 Ultra 256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 3600',
    package: 'RED BUSINESS 7.6GB', data: '7.6GB Anytime', minutes: '400', onceOff: '30GB',
    price: 1349, wasPrice: 1449, save: 3600, term: 36,
    priceAlt: 1799, termAlt: 24,
  },
  {
    id: 7, category: 'Business Devices', name: 'iPhone 17 256GB 5G',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 1800',
    package: 'RED BUSINESS 3.7GB', data: '3.7GB Anytime', minutes: '150', onceOff: '30GB',
    price: 849, wasPrice: 899, save: 1800, term: 36,
    priceAlt: 1149, termAlt: 24,
  },
  {
    id: 8, category: 'Business Devices', name: 'iPhone 17e 256GB 5G',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'RED BUSINESS 3.7GB', data: '3.7GB Anytime', minutes: '150', onceOff: '30GB',
    price: 999, wasPrice: null, save: null, term: 36,
    priceAlt: 1199, termAlt: 24,
  },
  {
    id: 9, category: 'Business Devices', name: 'iPhone 16e 128GB 5G',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'RED BUSINESS 3.7GB', data: '3.7GB Anytime', minutes: '150', onceOff: '30GB',
    price: 519, wasPrice: null, save: null, term: 36,
    priceAlt: 719, termAlt: 24,
  },
  {
    id: 10, category: 'Business Devices', name: 'Lenovo IdeaPad 3 Core i7 15.6"',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '40GB DATA', data: '20GB Anytime + 20GB Night Owl', minutes: null, onceOff: null,
    price: 849, wasPrice: null, save: null, term: 24,
    priceAlt: null, termAlt: null,
    note: 'Includes MIFI Router.',
  },
  {
    id: 11, category: 'Business Devices', name: 'Samsung Galaxy Tab S10 Lite 5G',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '40GB DATA', data: '20GB Anytime + 20GB Night Owl', minutes: null, onceOff: null,
    price: 549, wasPrice: null, save: null, term: 24,
    priceAlt: null, termAlt: null,
  },
];

export const BUSINESS_CATEGORIES = ['All', 'SIM-Only', 'Business Internet', 'Business Devices'];
